import Vue from 'vue';


const success = (context, response) => {
  context.user.rights = response.data.rights;
  context.user.currency = response.data.currency;
  context.user.is_team_member = response.data.is_team_member;
  context.user.parent_emails = response.data.parent_emails;
  context.user.plan_id = response.data.plan_id;
  if (context.rentals && context.rentals.length === 0) {
    if (context.user.is_team_member) {
      response.data.rentals.forEach((userRental) => {
        context.rentals.push(userRental.rental);
      });
    } else {
      context.rentals = response.data.rentals;
    }
  }
};

const failed = () => {

};

export default context => Vue.$http.get('/account-rights').then((response) => {
  if (response && response.status === 200) {
    success(context, response);
  }
})
.catch((error) => {
  failed(error, context);
});



// WEBPACK FOOTER //
// ./src/app/services/account/getAccountRights.js